import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import placeholderImage from "../assets/images/landing-page-image-6.jpg";
import checkIcon from "../assets/icons/check.svg";
// import ReactTooltip from "react-tooltip";
import { useAppSelector } from "../hooks/hooks";
import { makeSessionRequest } from "../utils/makeSessionRequest";
const RenderThumbnails = ({ item, handleOptionSelection, getSelectedOption, }) => {
    var _a, _b, _c;
    const userConfig2 = useAppSelector((state) => state.configuration.userConfiguration2);
    const disabledOptions = useAppSelector((state) => state.configuration.disabledOptions);
    const disabledFeatures = useAppSelector((state) => state.configuration.disabledFeatures);
    let newDisabledFeatures = [];
    if (userConfig2["Wire Access"] && userConfig2["Wire Access"] !== "D-cut") {
        if (userConfig2["Wire Access"] === "Gromet") {
            newDisabledFeatures = ["FlipUp Position", ...disabledFeatures];
        }
        else if (userConfig2["Wire Access"] === "FlipUp") {
            newDisabledFeatures = ["Gromet Position", ...disabledFeatures];
        }
    }
    else {
        newDisabledFeatures = [
            ...newDisabledFeatures,
            "FlipUp Position",
            "Gromet Position",
        ];
    }
    function lastName(s) {
        return s
            .split(" ")
            .map((word) => {
            if (word === "FramE")
                return "Frame";
            // Replace all occurrences of "PrelaM" within the word.
            return word.replace(/PrelaM/g, "Prelam");
        })
            .join(" ");
    }
    //Navdeep commented this on 17:59 10-06-2024 to debug flickering issue ,whenever a single object is there for single subcategory
    // useEffect(() => {
    //   // select the first option if only one option exists
    //   const options = (item.options as Option[])?.filter(
    //     (option) => !disabledOptions.includes(option.name)
    //   );
    //   if (!options) {
    //     return;
    //   }
    //   const option = options[0];
    //   if (
    //     options.length > 0 &&
    //     getSelectedOption(item.name)[0]?.name === option.name
    //   ) {
    //     return;
    //   }
    //   if (options.length === 1) {
    //     handleOptionSelection({
    //       name: item.name,
    //       nodeName: item.nodeName,
    //       multiSelect: item.multiSelect,
    //       option,
    //       rules: item.rules,
    //     });
    //   }
    // }, [
    //   disabledOptions,
    //   getSelectedOption,
    //   handleOptionSelection,
    //   item.name,
    //   item.nodeName,
    //   item.options,
    //   item.rules,
    //   item.multiSelect,
    // ]);
    const isOptionSelected = (optionName) => {
        return getSelectedOption(item.name)
            .map((option) => option.name)
            .includes(optionName);
        // item.multiSelect?:getSelectedOption(item.name)?.name===optionName;
    };
    const getImage = (path) => {
        if (path &&
            !path.startsWith("/") &&
            !path.startsWith("http://") &&
            !path.startsWith("https://")) {
            return `/${path}`;
        }
        return path;
    };
    return (_jsxs("div", Object.assign({ className: "px-4" }, { children: [item.name && (_jsx("div", Object.assign({ className: "flex cursor-pointer flex-col items-center" }, { children: _jsx("h1", Object.assign({ className: " mt-4 text-xs 2xl:text-base font-bold mr-auto items-center justify-center" }, { children: item.name.toUpperCase() })) }))), _jsx("div", Object.assign({ className: "grid grid-cols-3 w-full  px-1" }, { children: (_a = item.options) === null || _a === void 0 ? void 0 : _a.filter((option) => !disabledOptions.includes(option.name)).map((option, index) => {
                    return (_jsxs("div", Object.assign({ onClick: () => {
                            makeSessionRequest("selected_option", Object.assign(Object.assign({}, (item.name && { itemName: item.name })), { selectedOption: option.name }));
                            handleOptionSelection({
                                name: item.name,
                                nodeName: item.nodeName,
                                option,
                                rules: item.rules,
                                multiSelect: item.multiSelect,
                            });
                        }, className: "cursor-pointer pt-5 mb-1 px-2 w-full flex flex-col items-center relative" }, { children: [_jsx("img", { src: getImage(option.thumbnail) || placeholderImage, className: " w-full border border-black border-opacity-20 ", alt: "" }), isOptionSelected(option.name) && (_jsx("img", { src: checkIcon, alt: "", className: "absolute top-2 right-1 " })), _jsx("h1", Object.assign({ 
                                // style={{ fontSize: ".6rem" }}
                                className: " whitespace-normal text-xs xl:text-xs mt-3 w-full break-words", "data-tip": option.name.length > 15 ? option.name : null }, { children: lastName(option.name) }))] }), option.name));
                }) })), (_c = (_b = getSelectedOption(item.name)) === null || _b === void 0 ? void 0 : _b.map((option) => option.options)) === null || _c === void 0 ? void 0 : _c.flat().filter((subFeature) => (subFeature === null || subFeature === void 0 ? void 0 : subFeature.name) && !newDisabledFeatures.includes(subFeature === null || subFeature === void 0 ? void 0 : subFeature.name)).map((subFeature) => subFeature ? (_jsx(RenderThumbnails, { item: subFeature, getSelectedOption: getSelectedOption, handleOptionSelection: handleOptionSelection })) : null)] })));
};
export default RenderThumbnails;
